import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { PiCityBold } from "react-icons/pi";
import { authenticationSeletor } from "@store/slices/authenticationSlice";
import { baseImgUrl } from "@api/client/api";
import ImagesData from "@assets/ImagesData";
import { VscHome, SlUser, LuHotel } from '@assets/Icons';
import { PiUserFill } from "react-icons/pi";
import { IoMdHelpCircleOutline } from "react-icons/io";
import { mainUrl } from '@api/client/api.js'
import { onLogout } from "@utils/utils";

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { access_token, userDetail, profileImg, localProfileImg, taDetails } = useSelector(authenticationSeletor);
    const { showModal } = useSelector((s) => s.showModal);
    const [activeIndex, setActiveIndex] = useState(1);

    useEffect(() => { window.scrollTo(0, 0) }, []);

    useEffect(() => {
        if (location?.pathname == '/home') { setActiveIndex(1) }
        else if (location?.pathname == '/contact') { setActiveIndex(2) }
        else if (location?.pathname == '/user-profile' && location?.state?.activeTab == "bookings") { setActiveIndex(3) }
        else if (location?.pathname == '/user-profile' && location?.state?.activeTab == "profile") { setActiveIndex(4) }
    }, [location])

    useEffect(() => {
        const currentUrl = window.location.origin;
        if (currentUrl == "http://rrooms.in" && userDetail?.propertyId) { onLogout(navigate) }
    }, [location, navigate, userDetail, onLogout]);


    return (
        <>
            <header className="header">
                <div className="container">
                    <div className="row justify-content-between align-items-center">
                        <Link to="/" className="logo">
                            <img src={ImagesData?.LogoIcon} title="Best hourly hotels" alt="Best hourly hotels" />
                            <h1>RROOMS</h1>
                        </Link>
                        <div className='right d-flex align-items-center'>
                            <div className='user-control text-white v-center mr-8'>
                                {
                                    Object.keys(taDetails ?? {})?.length > 0 ? '' :
                                        <>
                                            <PiCityBold size={32} className="mr-1" />
                                            <a target="_blank" href={mainUrl == 'https://rrooms.in/rrooms/' ? 'https://rrooms360.in/' : 'https://rrooms360.rrooms.co.in/login'} className="">
                                                Login to Extranet
                                            </a>
                                        </>
                                }
                            </div>
                            <div className='user-action'>
                                {
                                    userDetail?.id ? (
                                        <button className="v-center" onClick={() => navigate("/user-profile")}>
                                            <PiUserFill size={20} className="mr-1" />
                                            <span>
                                                {userDetail.name && userDetail.name != "" ? userDetail.name.split(" ")[0] : "Profile"}
                                            </span>
                                        </button>
                                    ) : taDetails?.firstName ? (
                                        <button className="v-center" onClick={() => navigate("/ta-profile")}>
                                            <PiUserFill size={20} className="mr-1" />
                                            <span>{taDetails?.firstName}</span>
                                        </button>
                                    ) : (<Link to='/login' className='btn btn-primary-outline btn-sm'>Login/Register</Link>)
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div className="app-header">
                <Link to="/" className="logo d-block">
                    <img src={ImagesData?.LogoIcon} title="Best hourly hotels" alt="Best hourly hotels" />
                    <h1>RRooms</h1>
                </Link>
                <ul>
                    <li>
                        <span className={access_token ? 'logged' : ''}>
                            <Link to={access_token ? '/user-profile' : '/login'} state={{ activeTab: 'profile' }}>
                                <img src={access_token ? `${localProfileImg ? baseImgUrl + localProfileImg : baseImgUrl + userDetail?.profileImage}` : ImagesData?.IconProfile} title="Best hourly hotels" alt="Best hourly hotels" />
                            </Link>
                        </span>
                    </li>
                </ul>
            </div>
            <div className="app-nav">
                <ul>
                    <li className={activeIndex == 1 ? 'active' : ''} onClick={() => setActiveIndex(1)}>
                        <Link to='/' state={{ activeTab: 'bookings' }}>
                            <span className="icon"><VscHome size={20} /></span>
                            <span className="text">Home</span>
                        </Link>
                    </li>
                    <li className={activeIndex == 3 ? 'active' : ''} onClick={() => setActiveIndex(3)}>
                        <Link to={access_token ? '/user-profile' : '/login'} state={{ activeTab: 'bookings' }}>
                            <span className="icon"><LuHotel size={18} /></span>
                            <span className="text">Bookings</span>
                        </Link>
                    </li>
                    <li className={activeIndex == 2 ? 'active' : ''} onClick={() => setActiveIndex(2)}>
                        <Link to='/contact' state={{ activeTab: 'bookings' }}>
                            <span className="icon"><IoMdHelpCircleOutline size={20} /></span>
                            <span className="text">Help</span>
                        </Link>
                    </li>
                    <li className={activeIndex == 4 ? 'active' : ''} onClick={() => setActiveIndex(4)}>
                        <Link to={access_token ? '/user-profile' : '/login'} state={{ activeTab: 'profile' }}>
                            <span className="icon"><SlUser size={18} /></span>
                            <span className="text">Account</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default Header;